import { ArrowInSquareIcon } from "../../../images";
import { EllipsisTooltip } from "../../CustomTooltip";
import { useState } from "react";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import { ReuseButton } from "../../ReuseButton";
import { ExportRecommendedCsvModal } from "../../modal";

type Props = {
  isDisabled: boolean;
};

export const ExportRecommendedBtn = ({ isDisabled }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedExportContactsAccountsList } =
    useAppSelector(selectPermissions);

  return (
    <>
      <EllipsisTooltip tooltip={isDisabled ? "" : "Export to CSV"}>
        <ReuseButton
          onClick={() => setIsOpen(true)}
          disabled={!isAllowedExportContactsAccountsList || isDisabled}
          startIcon={
            <ArrowInSquareIcon
              color={
                isAllowedExportContactsAccountsList ? "#1D3E70" : "#A5B2C6"
              }
            />
          }
        >
          Export to CSV
        </ReuseButton>
      </EllipsisTooltip>

      {isOpen && (
        <ExportRecommendedCsvModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
